
import React, { useState } from 'react';
import { SpecializedTutoringDialog } from './components/SpecializedTutoringDialog';
import { SpecializedTutoringTable } from './components/SpecializedTutoringTable';
import { useSpecializedTutorings, TeacherSpecializedTutoring } from '@/hooks/useSpecializedTutorings';

interface SpecializedTutoringManagerProps {
  teacherCode: string;
}

export function SpecializedTutoringManager({ teacherCode }: SpecializedTutoringManagerProps) {
  const [editingTutoring, setEditingTutoring] = useState<TeacherSpecializedTutoring | null>(null);
  
  const {
    availableTutorings,
    teacherTutorings,
    isLoading,
    addNewTutoringOption,
    addTeacherTutoring,
    updateTeacherTutoring,
    deleteTeacherTutoring
  } = useSpecializedTutorings(teacherCode);

  const handleSubmit = async (tutoring: string, description?: string) => {
    if (editingTutoring) {
      return await updateTeacherTutoring(editingTutoring.id, tutoring, description);
    } else {
      return await addTeacherTutoring(tutoring, description);
    }
  };

  if (isLoading) {
    return <div className="text-center py-4">กำลังโหลด...</div>;
  }

  return (
    <div className="space-y-4">
      <div className="flex justify-between items-center">
        <h4 className="text-md font-semibold">การติวสอบพิเศษ</h4>
        <SpecializedTutoringDialog
          availableTutorings={availableTutorings}
          editingTutoring={editingTutoring}
          onSubmit={handleSubmit}
          onEditingChange={setEditingTutoring}
          onAddNewOption={addNewTutoringOption}
        />
      </div>

      <SpecializedTutoringTable
        tutorings={teacherTutorings}
        onEdit={setEditingTutoring}
        onDelete={deleteTeacherTutoring}
      />
    </div>
  );
}
